import { render, staticRenderFns } from "./postal.vue?vue&type=template&id=7652d3da&scoped=true&"
import script from "./postal.vue?vue&type=script&lang=js&"
export * from "./postal.vue?vue&type=script&lang=js&"
import style0 from "./postal.vue?vue&type=style&index=0&id=7652d3da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7652d3da",
  null
  
)

export default component.exports